import { createMachine } from 'xstate'
export const KioskAntrianMachine =
/** @xstate-layout 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 */

/** @xstate-layout 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 */
createMachine({
  /** @xstate-layout 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 */
  id: 'KioskAntrian',
  initial: 'INITIAL_CONFIGURATION',

  states: {
    INITIAL_CONFIGURATION: {
      entry: 'setCtxConfiguration',

      states: {
        PAGE_HOME: {
          initial: 'INIT',

          states: {
            INIT: {
              on: {
                'click:everywhere': {
                  target: 'MENU_PAGE'
                },
                'scan:ticket': {
                  target: 'VALIDATION_TICKET',
                  actions: ['setCtxTypeActive', 'setCtxObjTicketResult']
                }
              },

              entry: 'setCtxPageIdle'
            },

            MENU_PAGE: {
              entry: ['setCtxListMenu', 'setCtxPageMenu', 'deleteCtxSelected'],

              on: {
                'scan:ticket': {
                  target: 'VALIDATION_TICKET',
                  actions: ['setCtxTypeActive', 'setCtxObjTicketResult']
                },

                'select:menu': [{
                  target: 'PENDAFTARAN_CHECK_UNIT',
                  cond: 'isTypeBooking',
                  actions: 'setCtxTypeActive'
                }, {
                  target: 'PENDAFTARAN_CHECK_UNIT',
                  cond: 'isTypeWalkIn',
                  actions: 'setCtxTypeActive'
                }, {
                  target: 'HOLD_TICKET',
                  cond: 'isTypeUnit',
                  actions: ['setCtxSelectUnit']
                }],

                'click:anywhere': 'MENU_PAGE'
              },

              after: {
                timeToIdlePage: 'INIT'
              }
            },

            VALIDATION_TICKET: {
              entry: ['setCtxModeTicket'],
              always: [
                {
                  target: 'VALIDATION_PENDAFTARAN',
                  cond: 'isCodeBooking',
                  actions: 'setCtxStrKeyCode'
                },
                {
                  target: 'VALIDATION_UNIT',
                  cond: 'isCodeTicket'
                }
              ]
            },

            VALIDATION_PENDAFTARAN: {
              always: [{
                target: 'VALIDATION_PENDAFTARAN_QUEUE',
                cond: 'isHavePendaftaranOnlyOne',
                actions: 'selectCtxPendaftaranOne'
              }, {
                target: 'NOT_SCAN_TICKET',
                cond: 'isNotHavePendaftran'
              }, 'SHOW_MODAL_PENDAFTRAN'],

              entry: ['setCtxListWithType']
            },

            VALIDATION_UNIT: {
              always: [{
                target: 'SHOW_MODAL_CONFIRM_UNIT',
                cond: 'isHaveUnitOnlyOne'
              }, {
                target: 'NOT_SCAN_TICKET_UNIT',
                cond: 'isNotHaveUnit'
              }, 'SHOW_MODAL_UNIT'],

              entry: ['setCtxListWithType', 'setCtxModalListPendaftaran', 'setCtxPageMenu']
            },

            VALIDATION_UNIT_QUEUE: {
              entry: 'setCtxPageLoading',

              invoke: {
                src: 'getInfoTicket',
                onError: [{
                  target: 'ERROR_500',
                  cond: 'isServer500'
                }, 'ERROR_PAGE_UNIT']
              },

              on: {
                'on:info:ticket': {
                  target: 'TICKET_FLOW',
                  actions: 'setCtxTicketQueue'
                }
              },

              after: {
                waitResponse: 'ERROR_PAGE_UNIT'
              }
            },

            NOT_SCAN_TICKET: {
              always: 'MENU_PAGE'
            },

            SHOW_MODAL_PENDAFTRAN: {
              entry: ['setCtxModalListPendaftaran', 'setCtxPageMenu', 'setCtxModalOpenOther'],

              on: {
                'select:confirmation': {
                  target: 'VALIDATION_PENDAFTARAN_QUEUE',
                  actions: ['setCtxSelectPendaftaran', 'setCtxModalCloseOther']
                },

                'button:cancel': {
                  target: 'MENU_PAGE',
                  actions: 'setCtxModalCloseOther'
                }
              },

              after: {
                timeOutCancel: {
                  target: 'MENU_PAGE',
                  actions: 'setCtxModalCloseOther'
                }
              }
            },

            NOT_SCAN_TICKET_UNIT: {
              after: {
                500: 'MENU_PAGE'
              }
            },

            SHOW_MODAL_UNIT: {
              entry: ['setCtxModalOpenOther'],

              after: {
                timeOutCancel: {
                  target: 'MENU_PAGE',
                  actions: 'setCtxModalCloseOther'
                }
              },

              on: {
                'select:confirmation': {
                  target: 'VALIDATION_UNIT_QUEUE',
                  actions: ['setCtxSelectUnit', 'setCtxModalCloseOther']
                },

                'button:cancel': {
                  target: 'MENU_PAGE',
                  actions: 'setCtxModalCloseOther'
                }
              }
            },

            SHOW_MODAL_CONFIRM_UNIT: {
              entry: ['setCtxModalSingleSelect'],

              on: {
                'button:lanjutkan': {
                  target: 'VALIDATION_UNIT_QUEUE',
                  actions: 'setCtxModalCloseSingleSelect'
                },

                'button:batalkan': {
                  target: 'MENU_PAGE',
                  actions: 'setCtxModalCloseSingleSelect'
                },

                'click:anywhere': 'SHOW_MODAL_CONFIRM_UNIT'
              },

              after: {
                timeOutLinear: {
                  target: 'MENU_PAGE',
                  actions: 'setCtxModalCloseSingleSelect'
                }
              }
            },

            VALIDATION_PENDAFTARAN_QUEUE: {
              invoke: {
                src: 'getInfoBooking',

                onError: [{
                  target: 'ERROR_500',
                  cond: 'isServer500'
                }, 'ERROR_PAGE_BOOKING']
              },

              on: {
                'on:info:booking': {
                  target: 'BOOKING_FLOW',
                  actions: 'setCtxListBooking'
                }
              },

              entry: 'setCtxPageLoading',

              after: {
                waitResponse: 'ERROR_PAGE_BOOKING'
              }
            },

            ERROR_PAGE_BOOKING: {
              entry: 'setCtxPageErrorQueue',

              after: {
                timeOutCancel: 'MENU_PAGE'
              },

              on: {
                'button:cancel': 'MENU_PAGE'
              }
            },

            BOOKING_FLOW: {
              states: {
                INIT_BOOKING: {
                  always: [{
                    target: 'CHECK_PRINTER',
                    cond: 'isBookingHaveOne'
                  }, 'SHOW_LIST_BOOKING']
                },

                SHOW_LIST_BOOKING: {
                  entry: 'setCtxPageBookingList',

                  on: {
                    'button:cetak': 'CHECK_PRINTER',
                    'button:batalkan': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE',

                    'click:anywhere': 'SHOW_LIST_BOOKING'
                  },

                  after: {
                    timeOutLinear: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  }
                },

                CREATE_QUEUE_TO_PENDAFTARAN: {
                  invoke: {
                    src: 'postQueuePendaftaran',
                    onError: [{
                      target: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.ERROR_500',
                      cond: 'isServer500'
                    }, '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.ERROR_PAGE_BOOKING']
                  },

                  on: {
                    'on:create:pendaftaran': {
                      target: 'SHOW_SUCCESS_PENDAFTARAN',
                      actions: ['setCtxListQueue', 'setCtxTicketMe']
                    }
                  },

                  entry: ['setCtxPageLoading', 'createCancelToken'],

                  after: {
                    waitResponse: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.ERROR_PAGE_BOOKING'
                  },

                  exit: 'cancelRequest'
                },

                SHOW_SUCCESS_PENDAFTARAN: {
                  entry: ['setCtxSuccessTicket', 'setCtxPageSuccessPendaftaran'],

                  invoke: {
                    src: 'printTicket',
                    onError: '.SEND_ERROR'
                  },

                  on: {
                    'button:ok': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE',
                    'button:cancel': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  },

                  after: {
                    timeOutCancel: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  },

                  states: {
                    INIT: {},
                    SEND_ERROR: {
                      invoke: {
                        src: 'sendErrorPrint'
                      }
                    }
                  },

                  initial: 'INIT'
                },

                CONFIRM_PRINT: {
                  on: {
                    'button:lanjutkan': 'CREATE_QUEUE_TO_PENDAFTARAN',
                    'button:batalkan': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  },

                  entry: 'setCtxPageErrorPrinter'
                },

                CHECK_PRINTER: {
                  states: {
                    INIT: {
                      always: 'CHECK_PRINTER_STATUS'
                    },

                    CHECK_PRINTER_STATUS: {
                      invoke: {
                        src: 'getStatusPrinterUSB',
                        onDone: 'DONE',
                        onError: 'DONE'
                      }
                    },

                    DONE: {
                      type: 'final',
                      entry: 'setCtxErrorPrinter'
                    }
                  },

                  initial: 'INIT',

                  onDone: [{
                    target: 'CREATE_QUEUE_TO_PENDAFTARAN',
                    cond: 'isPrinterOK'
                  }, 'CONFIRM_PRINT']
                }
              },

              initial: 'INIT_BOOKING'
            },

            ERROR_PAGE_UNIT: {
              on: {
                'button:cancel': 'MENU_PAGE'
              },

              after: {
                timeOutCancel: 'MENU_PAGE'
              },

              entry: 'setCtxPageErrorQueue'
            },

            TICKET_FLOW: {
              states: {
                INIT_TICKET: {
                  always: [{
                    target: 'DOUBLE_CHECK_IN',
                    cond: 'isWithCheck',
                    actions: 'setCtxDoubleCheck'
                  }, {
                    target: 'SHOW_INFO_QUEUE',
                    cond: 'isListQueue'
                  }, {
                    target: 'SHOW_PAGE_LOAD',
                    cond: 'isNotRegistration',
                    actions: 'setCtxNotRegist'
                  }, 'CREATE_QUEUE_UNIT'],

                  entry: ['setCtxQueueList', 'setCtxSuccessTicket']
                },

                SHOW_INFO_QUEUE: {
                  entry: ['setCtxPageInfoQueue'],

                  on: {
                    'button:lanjutkan': 'CREATE_QUEUE_UNIT',
                    'button:batalkan': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE',

                    'click:anywhere': 'SHOW_INFO_QUEUE'
                  },

                  after: {
                    timeOutLinear: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  }
                },

                CREATE_QUEUE_UNIT: {
                  entry: 'setCtxPageLoading',

                  invoke: {
                    src: 'postQueueUnit',
                    onError: [{
                      target: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.ERROR_500',
                      cond: 'isServer500'
                    }, '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.ERROR_PAGE_UNIT']
                  },

                  after: {
                    waitResponse: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.ERROR_PAGE_UNIT'
                  },

                  on: {
                    'go:list': 'GET_ORDER_LINES'
                  }
                },

                SHOW_SUCCESS_UNIT: {
                  entry: 'setCtxPageSuccessQueue',

                  on: {
                    'button:ok': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  },

                  after: {
                    timeOutCancel: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  }
                },

                DOUBLE_CHECK_IN: {
                  entry: 'setCtxFailedTicket',

                  on: {
                    'on:create:unit': {
                      target: 'SHOW_SUCCESS_UNIT',
                      actions: 'setCtxListQueue'
                    }
                  },

                  invoke: {
                    src: 'getListAntrian'
                  }
                },

                GET_ORDER_LINES: {
                  invoke: {
                    src: 'getListAntrian'
                  },

                  exit: 'setCtxListQueue',

                  on: {
                    'on:create:unit': {
                      target: 'SHOW_SUCCESS_UNIT',
                      actions: 'setCtxListQueue'
                    }
                  }
                },

                BACK_TO_MENU: {
                  entry: 'setCtxPageMenu',

                  after: {
                    100: 'SHOW_ATTENTION_MODAL'
                  }
                },

                SHOW_ATTENTION_MODAL: {
                  entry: ['setCtxModalAttentionSingle', 'setCtxOnlyCheckInTicket'],
                  exit: ['setCtxModalCloseAttentionSingle', 'setCtxBackCheckInTicket'],

                  after: {
                    timeOutLinear: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  },

                  on: {
                    'click:anywhere': 'SHOW_ATTENTION_MODAL',
                    'button:batalkan': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE',
                    'button:lanjutkan': 'CREATE_QUEUE_UNIT'
                  }
                },

                SHOW_PAGE_LOAD: {
                  after: {
                    250: 'BACK_TO_MENU'
                  }
                }
              },

              initial: 'INIT_TICKET'
            },

            HOLD_TICKET: {
              entry: 'setCtxShowModalGIF',

              on: {
                'scan:ticket': [{
                  target: 'VALIDATION_UNIT_QUEUE',
                  cond: 'isTypeUnit',
                  actions: ['setCtxTypeActive', 'setCtxHideModalGIF']
                }, {
                  target: 'ERROR_PAGE_UNIT',
                  cond: 'isTypeBooking',
                  actions: 'setCtxHideModalGIF'
                }],

                'button:batalkan': {
                  target: 'MENU_PAGE',
                  actions: 'setCtxHideModalGIF'
                },

                'create:ticket:unit': {
                  target: 'SHOW_MODAL_ATTENTION',
                  actions: ['setCtxPendaftaranFromUnit', 'setCtxHideModalGIF', 'setCtxTypeActive']
                }
              },

              after: {
                timeOutCancel: {
                  target: 'MENU_PAGE',
                  actions: 'setCtxHideModalGIF'
                }
              }
            },

            PENDAFTARAN_CHECK_UNIT: {
              states: {
                INIT: {
                  always: [{
                    target: 'NEXT_STEP',
                    cond: 'isHavePendaftaranOnlyOne',
                    actions: 'selectCtxPendaftaranOne'
                  }, 'SHOW_MODAL_SELECT_PENDAFTARAN'],

                  entry: 'setCtxListWithType'
                },

                NEXT_STEP: {
                  type: 'final'
                },

                SHOW_MODAL_SELECT_PENDAFTARAN: {
                  entry: ['setCtxModalListPendaftaran', 'setCtxModalOpenOther'],

                  on: {
                    'select:confirmation': {
                      target: 'NEXT_STEP',
                      actions: 'setCtxSelectPendaftaran'
                    },

                    'button:cancel': {
                      target: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE',
                      actions: 'setCtxModalCloseOther'
                    }
                  },

                  after: {
                    timeOutCancel: {
                      target: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE',
                      actions: 'setCtxModalCloseOther'
                    }
                  },

                  exit: 'setCtxModalCloseOther'
                }
              },

              initial: 'INIT',

              onDone: [{
                target: 'BOOKING_FLOW.CHECK_PRINTER',
                cond: 'isTypeWalkIn'
              }, 'PAGE_INPUT_KEYPAD']
            },

            PAGE_INPUT_KEYPAD: {
              entry: ['setCtxPageInputKeypad'],

              on: {
                'button:lanjutkan': 'VALIDATION_CODE',

                'button:batalkan': {
                  target: 'MENU_PAGE',
                  actions: 'setCtxInputToZero'
                },

                'click:keypad': {
                  target: 'RESET_TIMEOUT',
                  actions: 'addCtxInputKey'
                },

                'click:anywhere': 'PAGE_INPUT_KEYPAD',
                'scan:ticket': {
                  target: 'VALIDATION_PENDAFTARAN',
                  actions: ['setCtxTypeActive', 'setCtxObjTicketResult', 'setCtxStrKeyCode'],
                  cond: 'isTypeBooking'
                }
              },

              after: {
                timeOutLinear: {
                  target: 'MENU_PAGE',
                  actions: 'setCtxInputToZero'
                }
              }
            },

            VALIDATION_CODE: {
              entry: ['setCtxPageLoading'],

              always: [{
                target: 'VALIDATION_PENDAFTARAN_QUEUE',
                cond: 'isCode'
              }, {
                target: 'GET_INFO_BY_PHONE',
                actions: 'setCtxKeyCheckNumber'
              }]
            },

            GET_INFO_BY_PHONE: {
              invoke: {
                src: 'getInfoBooking',
                onError: 'ERROR_PAGE_BOOKING'
              },

              on: {
                'on:info:booking': {
                  target: 'FLOW_CODE_OR_PHONE',
                  actions: 'setCtxListBookingWithPasient'
                }
              },

              after: {
                waitResponse: 'ERROR_PAGE_BOOKING'
              }
            },

            FLOW_CODE_OR_PHONE: {
              states: {
                INIT: {
                  always: [{
                    target: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.LIST_TO_BOOKING',
                    cond: 'isPatientOnlyOne',
                    actions: 'setCtxSelectPasient'
                  }, 'PAGE_PATIENT_SHOW'],

                  entry: 'setCtxDisabledButton'
                },

                CREATE_QUEUE_PENDAFTARAN_MULTIPLE: {
                  entry: 'setCtxPageLoading',

                  states: {
                    INIT: {
                      invoke: {
                        src: 'postQueuePendaftaranMultiple',

                        onDone: 'SUCCESS_CREATE_PENDAFTARAN'
                      }
                    },

                    SUCCESS_CREATE_PENDAFTARAN: {
                      entry: 'setCtxSuccessMultipleTicket',

                      on: {
                        'on:create:pendaftaran': {
                          target: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.FLOW_CODE_OR_PHONE.SHOW_SUCCESS_MULTIPLE_PENDAFTARAN',
                          actions: ['setCtxListQueue', 'setCtxTicketMe']
                        }
                      }
                    }
                  },

                  initial: 'INIT',

                  on: {
                    'after:pasien': {
                      target: '.INIT',
                      internal: false
                    }
                  }
                },

                PAGE_PATIENT_SHOW: {
                  entry: ['setCtxPageDoubleListPhone'],

                  on: {
                    'select:pasient': {
                      target: 'RESET_TIME',
                      actions: ['setCtxPasient', 'setCtxEnabledButton']
                    },

                    'button:lanjutkan': {
                      target: 'CHECK_PRINTER',
                      cond: 'isEnable'
                    },

                    'button:batalkan': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE',

                    'click:anywhere': 'PAGE_PATIENT_SHOW'
                  },

                  after: {
                    timeOutLinear: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  }
                },

                RESET_TIME: {
                  always: 'PAGE_PATIENT_SHOW'
                },

                SHOW_SUCCESS_MULTIPLE_PENDAFTARAN: {
                  entry: ['setCtxSuccessTicket', 'setCtxPageSuccessPendaftaran'],

                  states: {
                    INIT: {
                      invoke: {
                        src: 'printTicketMultiple',
                        onError: 'SEND_ERROR'
                      }
                    },

                    SEND_ERROR: {
                      invoke: {
                        src: 'sendErrorPrint'
                      }
                    }
                  },

                  initial: 'INIT',

                  on: {
                    'print:after': {
                      target: '.INIT',
                      internal: false
                    },

                    'button:ok': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE',
                    'button:cancel': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  },

                  after: {
                    timeOutCancel: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  }
                },

                CHECK_PRINTER: {
                  always: [{
                    target: 'CREATE_QUEUE_PENDAFTARAN_MULTIPLE',
                    cond: 'isPrinterOK'
                  }, 'CONFIRM_PRINT']
                },

                CONFIRM_PRINT: {
                  entry: 'setCtxPageErrorPrinter',

                  on: {
                    'button:lanjutkan': 'CREATE_QUEUE_PENDAFTARAN_MULTIPLE',
                    'button:batalkan': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  }
                }
              },

              initial: 'INIT'
            },

            RESET_TIMEOUT: {
              always: 'PAGE_INPUT_KEYPAD'
            },

            LIST_TO_BOOKING: {
              always: 'BOOKING_FLOW',
              entry: 'setCtxToBooking'
            },

            ERROR_500: {
              entry: 'setCtxPageErrorServer',

              on: {
                'button:cancel': 'MENU_PAGE'
              },

              after: {
                timeOutCancel: 'MENU_PAGE'
              }
            },

            SHOW_MODAL_ATTENTION: {
              entry: 'setCtxModalAttentionSingle',
              exit: 'setCtxModalCloseAttentionSingle',

              on: {
                'button:lanjutkan': 'BOOKING_FLOW.CHECK_PRINTER',
                'button:batalkan': 'MENU_PAGE',

                'click:anywhere': 'SHOW_MODAL_ATTENTION'
              },

              after: {
                timeOutLinear: 'MENU_PAGE'
              }
            }
          },

          entry: ['setCtxUnit', 'setCtxListPendaftaran']
        },

        VIDEO_ASSET: {
          states: {
            INIT: {
              invoke: {
                src: 'getAndSetVideo',
                onDone: 'DONE'
              }
            },

            DONE: {}
          },

          initial: 'INIT'
        },

        GET_LABEL: {
          states: {
            INIT: {
              invoke: {
                src: 'getLabelBadge',
                onDone: 'DONE'
              },

              exit: 'setCtxLabelBadge'
            },

            DONE: {}
          },

          initial: 'INIT'
        },

        LOADING_SCAN: {
          states: {
            INIT: {},

            PAGE_LOADING: {
              on: {
                'back:page': 'PAGE_BEFORE'
              }
            },

            PAGE_BEFORE: {}
          },

          initial: 'INIT',

          on: {
            'loading:page': '.PAGE_LOADING'
          }
        },

        REPRINT_TICKET: {
          states: {
            INIT: {},

            GET_LIST_ANTRIAN: {
              invoke: {
                src: 'getDataAntrian',
                onDone: 'CHANGE_GENERATED_ID'
              }
            },

            CHANGE_GENERATED_ID: {
              invoke: {
                src: 'postNewGeneratedId',
                onDone: 'PRINT_TICKET'
              }
            },

            PRINT_TICKET: {
              invoke: {
                src: 'printTicketQR'
              }
            }
          },

          initial: 'INIT',

          on: {
            'scan:reprint:ticket': {
              target: '.GET_LIST_ANTRIAN',
              internal: false
            }
          }
        },

        CHECK_PRINTER: {
          states: {
            INIT: {
              always: {
                target: 'GET_STATUS_PRINTER',
                cond: 'isStop'
              }
            },

            GET_STATUS_PRINTER: {
              invoke: {
                src: 'getStatusPrinter',
                onDone: 'SET_PRINTER_DATA',
                onError: 'SET_PRINTER_ERR_NETWORK'
              }
            },

            SET_PRINTER_DATA: {
              entry: 'setCtxErrorPrinter'
            },
            SET_PRINTER_ERR_NETWORK: {
              entry: 'setCtxErrorPrinter'
            }
          },

          initial: 'INIT',

          on: {
            'status:printer': {
              target: '.GET_STATUS_PRINTER',
              internal: false
            }
          }
        }
      },

      type: 'parallel'
    }
  },

  on: {
    'push:config': {
      target: '#KioskAntrian',
      actions: [
        'setCtxConfigNew',
        'setCtxUnit',
        'setCtxListPendaftaran',
        'setCtxHideModalGIF'
      ]
    }
  }
})
